export default {
      id: "logo-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }